import React, { useEffect, useState } from "react";
import styles from "./P2POrders.module.scss";
import Card from "../../../common/Card/Card";
import InputFormik from "../../../common/Formik/Input/InputFormik";
import { SearchIcon } from "../../../../assets/icons/svgicons";
import { NavLink, useLocation } from "react-router-dom";
import { ROUTES } from "../../../../routes";
import { useDispatch } from "react-redux";
import {
  getBuySellOrderListAction,
  getUserBuySellOrdersAction,
  getUserOrdersHistoryAction,
} from "../../../../features/user/userSlice";
import SellOrders from "./SellOrders/SellOrders";
import BuyOrders from "./BuyOrders/BuyOrders";
import MyOrders from "./MyTransactions/MyOrders";
import { useDebounce } from "../../../customHook/useDebeunce";
import {
  startLoading,
  stopLoading,
} from "../../../../features/loading/loadingSlice";

const P2POrders = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const debounced = useDebounce(search, 500);
  const [isP2P, setIsP2P] = useState();
  const [orderType, setOrderType] = useState("BUY");
  const [sortCol, setSortCol] = useState({});
  const [sortType, setSortType] = useState("");
  const [page, setPage] = useState(1);
  const size = 10;

  const setInitState = () => {
    setSearch("");
    setPage(1);
    setSortType("");
    setSortCol({});
  };

  useEffect(() => {
    let pathname = window.location.pathname.split("/");
    if (pathname[3] === "my-orders") {
      setIsP2P(false);
    } else {
      setIsP2P(true);
    }
    
    if (location.state?.tab === "sell") {
      setOrderType("SELL");
    } else if (location.state?.tab === "buy") {
      setOrderType("BUY");
    }
  }, [location.state]);

  const getBuySellOrders = async () => {
    try {
      dispatch(startLoading());
      const dataObj = {
        page: debounced ? 1 : page,
        size: size,
        type: orderType, 
        dateFilterVal: "MONTH", 
        ...sortCol,
      };
      if (debounced) {
        dataObj["searchKeyword"] = debounced;
      }
      await dispatch(getBuySellOrderListAction(dataObj));
    } catch (error) {
      console.log("error", error);
    } finally {
      dispatch(stopLoading());
    }
  };

  const getUserBuySellOrders = async () => {
    try {
      dispatch(startLoading());
      const dataObj = {
        page: debounced ? 1 : page,
        size: size,
        dateFilterVal: "MONTH", 
        ...sortCol,
      };
      if (debounced) {
        dataObj["searchKeyword"] = debounced;
      }
      if (orderType === "COMPLETED") {
        await dispatch(getUserOrdersHistoryAction(dataObj));
      } else {
        dataObj["type"] = orderType;
        await dispatch(getUserBuySellOrdersAction(dataObj));
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      dispatch(stopLoading());
    }
  };

  useEffect(() => {
    if (isP2P) {
      getBuySellOrders();
    } else {
      getUserBuySellOrders();
    }
    setTimeout(() => {
      setLoading(false);
    }, 1400);
  }, [isP2P, orderType, page, debounced, sortCol]);

  const handleSorting = (col) => {
    if (sortType === "ASC") {
      setSortType("DESC");
      setSortCol({ ["sortBy" + col]: "DESC" });
    } else if (sortType === "") {
      setSortType("ASC");
      setSortCol({ ["sortBy" + col]: "ASC" });
    } else {
      setSortType("");
      setSortCol({});
    }
  };

  return (
    <>
      <div className={styles.p2pSection}>
        <div className={styles.tabs}>
          <NavLink
            onClick={() => {
              setInitState();
              setIsP2P(true);
              setOrderType("BUY");
            }}
            to={ROUTES.P2P_ORDERS_LIST}
            activeClassName={styles.active}
          >
            P2P Orders
          </NavLink>
          <NavLink
            onClick={() => {
              setInitState();
              setIsP2P(false);
              setOrderType("BUY");
            }}
            to={ROUTES.MY_ORDERS}
            activeClassName={styles.active}
          >
            My Orders
          </NavLink>
        </div>
        <Card
          title={
            <>
              <span className="d-md-inline d-none">P2P Orders - Buy/Sell</span>{" "}
              List
            </>
          }
          className={styles.transactions}
          bodyClassName={styles.body}
          headerClassName={styles.headerCard}
          headerContent={
            <>
              <InputFormik
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                icon={<SearchIcon />}
                placeholder="Search by Order ID..."
                iconClassName={styles.search_icon}
                className={styles.search_input}
              />

              <div className={`${styles.tabs} ${styles.tabsNew}`}>
                <NavLink
                  onClick={(event) => {
                    event.preventDefault();
                    setInitState();
                    setOrderType("BUY");
                  }}
                  className={orderType === "BUY" ? "activeTab" : ""}
                >
                  Buy Orders
                </NavLink>
                <NavLink
                  onClick={(event) => {
                    event.preventDefault();
                    setInitState();
                    setOrderType("SELL");
                  }}
                  className={orderType === "SELL" ? "activeTab" : ""}
                >
                  Sell Orders
                </NavLink>
                {!isP2P && (
                  <NavLink
                    onClick={(event) => {
                      event.preventDefault();
                      setInitState();
                      setOrderType("COMPLETED");
                    }}
                    className={orderType === "COMPLETED" ? "activeTab" : ""}
                  >
                    Completed
                  </NavLink>
                )}
              </div>
            </>
          }
        >
          {isP2P ? (
            <div className={styles.tabContainer}>
              <div className={orderType === "BUY" ? "showData" : "hideTab"}>
                <BuyOrders
                  page={page}
                  setPage={setPage}
                  size={size}
                  handleSorting={handleSorting}
                  getBuySellOrders={getBuySellOrders}
                />
              </div>
              <div className={orderType === "SELL" ? "showData" : "hideTab"}>
                <SellOrders
                  page={page}
                  setPage={setPage}
                  size={size}
                  handleSorting={handleSorting}
                  getBuySellOrders={getBuySellOrders}
                />
              </div>
            </div>
          ) : (
            <div className={styles.tabContainer}>
              <MyOrders
                page={page}
                setPage={setPage}
                size={size}
                handleSorting={handleSorting}
                getUserBuySellOrders={getUserBuySellOrders}
                orderType={orderType} 
              />
            </div>
          )}
        </Card>
      </div>
    </>
  );
};

export default P2POrders;

